import { SocialNetwork } from "./types";

export const socialNetworksBaseUrl: { [key in SocialNetwork]: string } = {
  [SocialNetwork.Instagram]: "https://instagram.com/",
  [SocialNetwork.Facebook]: "https://facebook.com/",
  [SocialNetwork.TikTok]: "https://tiktok.com/@",
  [SocialNetwork.Twitter]: "https://twitter.com/",
};
